import clsx from 'clsx'
import useTranslation from 'next-translate/useTranslation'
import { memo } from 'react'
import { useFormContext } from 'react-hook-form'

import Product from '@/ts/Product'

import Field from './includes/Field'

function Fieldset({ sizes }: FieldsetProps) {
  const { t } = useTranslation('products')
  const { register } = useFormContext()

  return (
    <fieldset
      className={clsx('space-y-4', {
        hidden: sizes[0].name === 'One Size',
      })}
    >
      <legend>{t('choose_size')}</legend>
      <div className="flex flex-wrap">
        {sizes.map((size) => (
          <div key={size.id} className="relative mb-4 mr-4 max-w-max">
            <Field collectionSize={size} {...register('size_id')} />
          </div>
        ))}
      </div>
    </fieldset>
  )
}

interface FieldsetProps {
  sizes: Product['sizes']
}

export default memo(Fieldset)
